import React, { useCallback, useEffect } from 'react';
import LoadSpinner from 'components/LoadSpinner';
import Stops from 'components/Tracking/Stops';
import { ProvideTrackingPage, useTrackingPage } from './Tracking.hooks';
import {
  ColumnInfo,
  ColumnMap,
  Container,
  InfoContainer,
  PageError,
} from './Tracking.styled';
import Header from 'components/Tracking/Header';
import DriverMap from 'components/DriverMap';
import { useTranslation } from 'react-i18next';
import PageHeader from 'components/Tracking/PageHeader';
import { useDispatch } from 'react-redux';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import FeasibilityContextProvider from 'hooks/useFeasibility';
import { IS_TENANT } from 'tenant/utils';
import PageHeaderTenant from 'components/Tracking/PageHeaderTenant';

const TrackingPage = () => {
  const { data, loading, error } = useTrackingPage();
  const { t } = useTranslation('Tracking');

  const dispatch = useDispatch();
  const sendEvent = useCallback(
    (data) => dispatch(analyticsActions.sendEvent(data)),
    [dispatch]
  );

  const sendTrackingPageLoadedEvent = useCallback(() => {
    sendEvent(
      analyticsEvents.trackingPageLoaded({
        orderId: data.id,
      })
    );
  }, [data?.id, sendEvent]);

  useEffect(() => {
    if (data?.id) {
      sendTrackingPageLoadedEvent();
    }
  }, [data?.id, sendTrackingPageLoadedEvent]);

  return (
    <>
      {IS_TENANT && <PageHeaderTenant />}
      {!IS_TENANT && <PageHeader />}
      <Container>
        {error && (
          <PageError data-testid="tracking_error">{t('error')}</PageError>
        )}
        {loading && <LoadSpinner data-testid="tracking_loading" size="12" />}
        {!loading && !error && (
          <>
            <ColumnInfo>
              <InfoContainer>
                <Header />
                <Stops />
              </InfoContainer>
            </ColumnInfo>
            <ColumnMap>
              <DriverMap stops={data?.stops} drivers={data?.drivers} />
            </ColumnMap>
          </>
        )}
      </Container>
    </>
  );
};

const Tracking = ({ location }) => (
  <FeasibilityContextProvider>
    <ProvideTrackingPage queryString={location?.search}>
      <TrackingPage />
    </ProvideTrackingPage>
  </FeasibilityContextProvider>
);

export default Tracking;
